import { useMutation, UseMutationResult } from '@tanstack/react-query'
import {
  bulkCreateCompanyUsersCompaniesUsersBulkCreatePost,
  CompanyUserBulkCreateSchema,
  CompanyUserBulkResponseSchema,
  HTTPValidationError,
} from '@common/config/api/client'
import { AxiosError } from 'axios'

export const useBulkCreateCompanyUsers = (): UseMutationResult<
  CompanyUserBulkResponseSchema,
  AxiosError<HTTPValidationError>,
  { usersData: CompanyUserBulkCreateSchema }
> => {
  return useMutation<
    CompanyUserBulkResponseSchema,
    AxiosError<HTTPValidationError>,
    { usersData: CompanyUserBulkCreateSchema }
  >({
    mutationFn: async ({ usersData }) => {
      const response = await bulkCreateCompanyUsersCompaniesUsersBulkCreatePost({
        body: usersData,
        throwOnError: true,
      })
      return response.data
    },
  })
}
